import { createNodeDef } from "../../nodes.helpers";
import { DataFieldType } from "src/types/data-field.types";
import { incrementalNumber } from "@ngneat/falso";
import { expressionNodeDef } from "src/nodes/fako";

interface ToJson {
  toJSON(): string;
}

export const incrementalNumberNodeDef = createNodeDef({
  type: "incrementalNumber",
  displayName: "Incremental Number",
  defaultName: "incrementalNumber",
  description:
    "Provides a generator function for incremental numbers. Add an expression node and call the generator function to create a new value.",
  fields: [
    { type: DataFieldType.NUMBER, key: "from", label: "From" },
    { type: DataFieldType.NUMBER, key: "to", label: "To" },
    { type: DataFieldType.NUMBER, key: "step", label: "Step" },
  ],
  initialData: (): {
    from: number;
    to?: number;
    step: number;
  } => ({ from: 0, step: 1 }),
  autoNodes: (node) => [
    expressionNodeDef.create(undefined, {
      value: `${node.name}()`,
    }),
  ],
  generate: async ({ node, context }) => {
    const counter = incrementalNumber({
      from: node.data.from,
      to: node.data.to || undefined,
      step: node.data.step,
    });

    (counter as unknown as ToJson).toJSON = () => `Please call ${node.name}()`;
    context.append({ name: node.name, nodeType: node.type, value: counter });
  },
});
